module.exports = __webpack_public_path__ + "img/email.9efaec4.png";